import type { RegistryItem } from "shadcn/schema";

export const THEMES: RegistryItem[] = [
  {
    cssVars: {
      dark: {
        accent: "oklch(0.269 0 0)",
        "accent-foreground": "oklch(0.985 0 0)",
        background: "oklch(0.145 0 0)",
        border: "oklch(1 0 0 / 10%)",
        card: "oklch(0.205 0 0)",
        "card-foreground": "oklch(0.985 0 0)",
        "chart-1": "oklch(0.87 0 0)",
        "chart-2": "oklch(0.556 0 0)",
        "chart-3": "oklch(0.439 0 0)",
        "chart-4": "oklch(0.371 0 0)",
        "chart-5": "oklch(0.269 0 0)",
        destructive: "oklch(0.704 0.191 22.216)",
        foreground: "oklch(0.985 0 0)",
        input: "oklch(1 0 0 / 15%)",
        muted: "oklch(0.269 0 0)",
        "muted-foreground": "oklch(0.708 0 0)",
        popover: "oklch(0.205 0 0)",
        "popover-foreground": "oklch(0.985 0 0)",
        primary: "oklch(0.922 0 0)",
        "primary-foreground": "oklch(0.205 0 0)",
        ring: "oklch(0.556 0 0)",
        secondary: "oklch(0.269 0 0)",
        "secondary-foreground": "oklch(0.985 0 0)",
        sidebar: "oklch(0.205 0 0)",
        "sidebar-accent": "oklch(0.269 0 0)",
        "sidebar-accent-foreground": "oklch(0.985 0 0)",
        "sidebar-border": "oklch(1 0 0 / 10%)",
        "sidebar-foreground": "oklch(0.985 0 0)",
        "sidebar-primary": "oklch(0.488 0.243 264.376)",
        "sidebar-primary-foreground": "oklch(0.985 0 0)",
        "sidebar-ring": "oklch(0.556 0 0)",
      },
      light: {
        accent: "oklch(0.97 0 0)",
        "accent-foreground": "oklch(0.205 0 0)",
        background: "oklch(1 0 0)",
        border: "oklch(0.922 0 0)",
        card: "oklch(1 0 0)",
        "card-foreground": "oklch(0.145 0 0)",
        "chart-1": "oklch(0.87 0 0)",
        "chart-2": "oklch(0.556 0 0)",
        "chart-3": "oklch(0.439 0 0)",
        "chart-4": "oklch(0.371 0 0)",
        "chart-5": "oklch(0.269 0 0)",
        destructive: "oklch(0.577 0.245 27.325)",
        foreground: "oklch(0.145 0 0)",
        input: "oklch(0.922 0 0)",
        muted: "oklch(0.97 0 0)",
        "muted-foreground": "oklch(0.556 0 0)",
        popover: "oklch(1 0 0)",
        "popover-foreground": "oklch(0.145 0 0)",
        primary: "oklch(0.205 0 0)",
        "primary-foreground": "oklch(0.985 0 0)",
        radius: "0.625rem",
        ring: "oklch(0.708 0 0)",
        secondary: "oklch(0.97 0 0)",
        "secondary-foreground": "oklch(0.205 0 0)",
        sidebar: "oklch(0.985 0 0)",
        "sidebar-accent": "oklch(0.97 0 0)",
        "sidebar-accent-foreground": "oklch(0.205 0 0)",
        "sidebar-border": "oklch(0.922 0 0)",
        "sidebar-foreground": "oklch(0.145 0 0)",
        "sidebar-primary": "oklch(0.205 0 0)",
        "sidebar-primary-foreground": "oklch(0.985 0 0)",
        "sidebar-ring": "oklch(0.708 0 0)",
      },
    },
    name: "neutral",
    title: "Neutral",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        accent: "oklch(0.268 0.007 34.298)",
        "accent-foreground": "oklch(0.985 0.001 106.423)",
        background: "oklch(0.147 0.004 49.25)",
        border: "oklch(1 0 0 / 10%)",
        card: "oklch(0.216 0.006 56.043)",
        "card-foreground": "oklch(0.985 0.001 106.423)",
        "chart-1": "oklch(0.869 0.005 56.366)",
        "chart-2": "oklch(0.553 0.013 58.071)",
        "chart-3": "oklch(0.444 0.011 73.639)",
        "chart-4": "oklch(0.374 0.01 67.558)",
        "chart-5": "oklch(0.268 0.007 34.298)",
        destructive: "oklch(0.704 0.191 22.216)",
        foreground: "oklch(0.985 0.001 106.423)",
        input: "oklch(1 0 0 / 15%)",
        muted: "oklch(0.268 0.007 34.298)",
        "muted-foreground": "oklch(0.709 0.01 56.259)",
        popover: "oklch(0.216 0.006 56.043)",
        "popover-foreground": "oklch(0.985 0.001 106.423)",
        primary: "oklch(0.923 0.003 48.717)",
        "primary-foreground": "oklch(0.216 0.006 56.043)",
        ring: "oklch(0.553 0.013 58.071)",
        secondary: "oklch(0.268 0.007 34.298)",
        "secondary-foreground": "oklch(0.985 0.001 106.423)",
        sidebar: "oklch(0.216 0.006 56.043)",
        "sidebar-accent": "oklch(0.268 0.007 34.298)",
        "sidebar-accent-foreground": "oklch(0.985 0.001 106.423)",
        "sidebar-border": "oklch(1 0 0 / 10%)",
        "sidebar-foreground": "oklch(0.985 0.001 106.423)",
        "sidebar-primary": "oklch(0.488 0.243 264.376)",
        "sidebar-primary-foreground": "oklch(0.985 0.001 106.423)",
        "sidebar-ring": "oklch(0.553 0.013 58.071)",
      },
      light: {
        accent: "oklch(0.97 0.001 106.424)",
        "accent-foreground": "oklch(0.216 0.006 56.043)",
        background: "oklch(1 0 0)",
        border: "oklch(0.923 0.003 48.717)",
        card: "oklch(1 0 0)",
        "card-foreground": "oklch(0.147 0.004 49.25)",
        "chart-1": "oklch(0.869 0.005 56.366)",
        "chart-2": "oklch(0.553 0.013 58.071)",
        "chart-3": "oklch(0.444 0.011 73.639)",
        "chart-4": "oklch(0.374 0.01 67.558)",
        "chart-5": "oklch(0.268 0.007 34.298)",
        destructive: "oklch(0.577 0.245 27.325)",
        foreground: "oklch(0.147 0.004 49.25)",
        input: "oklch(0.923 0.003 48.717)",
        muted: "oklch(0.97 0.001 106.424)",
        "muted-foreground": "oklch(0.553 0.013 58.071)",
        popover: "oklch(1 0 0)",
        "popover-foreground": "oklch(0.147 0.004 49.25)",
        primary: "oklch(0.216 0.006 56.043)",
        "primary-foreground": "oklch(0.985 0.001 106.423)",
        radius: "0.625rem",
        ring: "oklch(0.709 0.01 56.259)",
        secondary: "oklch(0.97 0.001 106.424)",
        "secondary-foreground": "oklch(0.216 0.006 56.043)",
        sidebar: "oklch(0.985 0.001 106.423)",
        "sidebar-accent": "oklch(0.97 0.001 106.424)",
        "sidebar-accent-foreground": "oklch(0.216 0.006 56.043)",
        "sidebar-border": "oklch(0.923 0.003 48.717)",
        "sidebar-foreground": "oklch(0.147 0.004 49.25)",
        "sidebar-primary": "oklch(0.216 0.006 56.043)",
        "sidebar-primary-foreground": "oklch(0.985 0.001 106.423)",
        "sidebar-ring": "oklch(0.709 0.01 56.259)",
      },
    },
    name: "stone",
    title: "Stone",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        accent: "oklch(0.274 0.006 286.033)",
        "accent-foreground": "oklch(0.985 0 0)",
        background: "oklch(0.141 0.005 285.823)",
        border: "oklch(1 0 0 / 10%)",
        card: "oklch(0.21 0.006 285.885)",
        "card-foreground": "oklch(0.985 0 0)",
        "chart-1": "oklch(0.871 0.006 286.286)",
        "chart-2": "oklch(0.552 0.016 285.938)",
        "chart-3": "oklch(0.442 0.017 285.786)",
        "chart-4": "oklch(0.37 0.013 285.805)",
        "chart-5": "oklch(0.274 0.006 286.033)",
        destructive: "oklch(0.704 0.191 22.216)",
        foreground: "oklch(0.985 0 0)",
        input: "oklch(1 0 0 / 15%)",
        muted: "oklch(0.274 0.006 286.033)",
        "muted-foreground": "oklch(0.705 0.015 286.067)",
        popover: "oklch(0.21 0.006 285.885)",
        "popover-foreground": "oklch(0.985 0 0)",
        primary: "oklch(0.92 0.004 286.32)",
        "primary-foreground": "oklch(0.21 0.006 285.885)",
        ring: "oklch(0.552 0.016 285.938)",
        secondary: "oklch(0.274 0.006 286.033)",
        "secondary-foreground": "oklch(0.985 0 0)",
        sidebar: "oklch(0.21 0.006 285.885)",
        "sidebar-accent": "oklch(0.274 0.006 286.033)",
        "sidebar-accent-foreground": "oklch(0.985 0 0)",
        "sidebar-border": "oklch(1 0 0 / 10%)",
        "sidebar-foreground": "oklch(0.985 0 0)",
        "sidebar-primary": "oklch(0.488 0.243 264.376)",
        "sidebar-primary-foreground": "oklch(0.985 0 0)",
        "sidebar-ring": "oklch(0.552 0.016 285.938)",
      },
      light: {
        accent: "oklch(0.967 0.001 286.375)",
        "accent-foreground": "oklch(0.21 0.006 285.885)",
        background: "oklch(1 0 0)",
        border: "oklch(0.92 0.004 286.32)",
        card: "oklch(1 0 0)",
        "card-foreground": "oklch(0.141 0.005 285.823)",
        "chart-1": "oklch(0.871 0.006 286.286)",
        "chart-2": "oklch(0.552 0.016 285.938)",
        "chart-3": "oklch(0.442 0.017 285.786)",
        "chart-4": "oklch(0.37 0.013 285.805)",
        "chart-5": "oklch(0.274 0.006 286.033)",
        destructive: "oklch(0.577 0.245 27.325)",
        foreground: "oklch(0.141 0.005 285.823)",
        input: "oklch(0.92 0.004 286.32)",
        muted: "oklch(0.967 0.001 286.375)",
        "muted-foreground": "oklch(0.552 0.016 285.938)",
        popover: "oklch(1 0 0)",
        "popover-foreground": "oklch(0.141 0.005 285.823)",
        primary: "oklch(0.21 0.006 285.885)",
        "primary-foreground": "oklch(0.985 0 0)",
        radius: "0.625rem",
        ring: "oklch(0.705 0.015 286.067)",
        secondary: "oklch(0.967 0.001 286.375)",
        "secondary-foreground": "oklch(0.21 0.006 285.885)",
        sidebar: "oklch(0.985 0 0)",
        "sidebar-accent": "oklch(0.967 0.001 286.375)",
        "sidebar-accent-foreground": "oklch(0.21 0.006 285.885)",
        "sidebar-border": "oklch(0.92 0.004 286.32)",
        "sidebar-foreground": "oklch(0.141 0.005 285.823)",
        "sidebar-primary": "oklch(0.21 0.006 285.885)",
        "sidebar-primary-foreground": "oklch(0.985 0 0)",
        "sidebar-ring": "oklch(0.705 0.015 286.067)",
      },
    },
    name: "zinc",
    title: "Zinc",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        accent: "oklch(0.263 0.024 320.12)",
        "accent-foreground": "oklch(0.985 0 0)",
        background: "oklch(0.145 0.008 326)",
        border: "oklch(1 0 0 / 10%)",
        card: "oklch(0.212 0.019 322.12)",
        "card-foreground": "oklch(0.985 0 0)",
        "chart-1": "oklch(0.865 0.012 325.68)",
        "chart-2": "oklch(0.542 0.034 322.5)",
        "chart-3": "oklch(0.435 0.029 321.78)",
        "chart-4": "oklch(0.364 0.029 323.89)",
        "chart-5": "oklch(0.263 0.024 320.12)",
        destructive: "oklch(0.704 0.191 22.216)",
        foreground: "oklch(0.985 0 0)",
        input: "oklch(1 0 0 / 15%)",
        muted: "oklch(0.263 0.024 320.12)",
        "muted-foreground": "oklch(0.711 0.019 323.02)",
        popover: "oklch(0.212 0.019 322.12)",
        "popover-foreground": "oklch(0.985 0 0)",
        primary: "oklch(0.922 0.005 325.62)",
        "primary-foreground": "oklch(0.212 0.019 322.12)",
        ring: "oklch(0.542 0.034 322.5)",
        secondary: "oklch(0.263 0.024 320.12)",
        "secondary-foreground": "oklch(0.985 0 0)",
        sidebar: "oklch(0.212 0.019 322.12)",
        "sidebar-accent": "oklch(0.263 0.024 320.12)",
        "sidebar-accent-foreground": "oklch(0.985 0 0)",
        "sidebar-border": "oklch(1 0 0 / 10%)",
        "sidebar-foreground": "oklch(0.985 0 0)",
        "sidebar-primary": "oklch(0.488 0.243 264.376)",
        "sidebar-primary-foreground": "oklch(0.985 0 0)",
        "sidebar-ring": "oklch(0.542 0.034 322.5)",
      },
      light: {
        accent: "oklch(0.96 0.003 325.6)",
        "accent-foreground": "oklch(0.212 0.019 322.12)",
        background: "oklch(1 0 0)",
        border: "oklch(0.922 0.005 325.62)",
        card: "oklch(1 0 0)",
        "card-foreground": "oklch(0.145 0.008 326)",
        "chart-1": "oklch(0.865 0.012 325.68)",
        "chart-2": "oklch(0.542 0.034 322.5)",
        "chart-3": "oklch(0.435 0.029 321.78)",
        "chart-4": "oklch(0.364 0.029 323.89)",
        "chart-5": "oklch(0.263 0.024 320.12)",
        destructive: "oklch(0.577 0.245 27.325)",
        foreground: "oklch(0.145 0.008 326)",
        input: "oklch(0.922 0.005 325.62)",
        muted: "oklch(0.96 0.003 325.6)",
        "muted-foreground": "oklch(0.542 0.034 322.5)",
        popover: "oklch(1 0 0)",
        "popover-foreground": "oklch(0.145 0.008 326)",
        primary: "oklch(0.212 0.019 322.12)",
        "primary-foreground": "oklch(0.985 0 0)",
        radius: "0.625rem",
        ring: "oklch(0.711 0.019 323.02)",
        secondary: "oklch(0.96 0.003 325.6)",
        "secondary-foreground": "oklch(0.212 0.019 322.12)",
        sidebar: "oklch(0.985 0 0)",
        "sidebar-accent": "oklch(0.96 0.003 325.6)",
        "sidebar-accent-foreground": "oklch(0.212 0.019 322.12)",
        "sidebar-border": "oklch(0.922 0.005 325.62)",
        "sidebar-foreground": "oklch(0.145 0.008 326)",
        "sidebar-primary": "oklch(0.212 0.019 322.12)",
        "sidebar-primary-foreground": "oklch(0.985 0 0)",
        "sidebar-ring": "oklch(0.711 0.019 323.02)",
      },
    },
    name: "mauve",
    title: "Mauve",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        accent: "oklch(0.286 0.016 107.4)",
        "accent-foreground": "oklch(0.988 0.003 106.5)",
        background: "oklch(0.153 0.006 107.1)",
        border: "oklch(1 0 0 / 10%)",
        card: "oklch(0.228 0.013 107.4)",
        "card-foreground": "oklch(0.988 0.003 106.5)",
        "chart-1": "oklch(0.88 0.011 106.6)",
        "chart-2": "oklch(0.58 0.031 107.3)",
        "chart-3": "oklch(0.466 0.025 107.3)",
        "chart-4": "oklch(0.394 0.023 107.4)",
        "chart-5": "oklch(0.286 0.016 107.4)",
        destructive: "oklch(0.704 0.191 22.216)",
        foreground: "oklch(0.988 0.003 106.5)",
        input: "oklch(1 0 0 / 15%)",
        muted: "oklch(0.286 0.016 107.4)",
        "muted-foreground": "oklch(0.737 0.021 106.9)",
        popover: "oklch(0.228 0.013 107.4)",
        "popover-foreground": "oklch(0.988 0.003 106.5)",
        primary: "oklch(0.93 0.007 106.5)",
        "primary-foreground": "oklch(0.228 0.013 107.4)",
        ring: "oklch(0.58 0.031 107.3)",
        secondary: "oklch(0.286 0.016 107.4)",
        "secondary-foreground": "oklch(0.988 0.003 106.5)",
        sidebar: "oklch(0.228 0.013 107.4)",
        "sidebar-accent": "oklch(0.286 0.016 107.4)",
        "sidebar-accent-foreground": "oklch(0.988 0.003 106.5)",
        "sidebar-border": "oklch(1 0 0 / 10%)",
        "sidebar-foreground": "oklch(0.988 0.003 106.5)",
        "sidebar-primary": "oklch(0.488 0.243 264.376)",
        "sidebar-primary-foreground": "oklch(0.988 0.003 106.5)",
        "sidebar-ring": "oklch(0.58 0.031 107.3)",
      },
      light: {
        accent: "oklch(0.966 0.005 106.5)",
        "accent-foreground": "oklch(0.228 0.013 107.4)",
        background: "oklch(1 0 0)",
        border: "oklch(0.93 0.007 106.5)",
        card: "oklch(1 0 0)",
        "card-foreground": "oklch(0.153 0.006 107.1)",
        "chart-1": "oklch(0.88 0.011 106.6)",
        "chart-2": "oklch(0.58 0.031 107.3)",
        "chart-3": "oklch(0.466 0.025 107.3)",
        "chart-4": "oklch(0.394 0.023 107.4)",
        "chart-5": "oklch(0.286 0.016 107.4)",
        destructive: "oklch(0.577 0.245 27.325)",
        foreground: "oklch(0.153 0.006 107.1)",
        input: "oklch(0.93 0.007 106.5)",
        muted: "oklch(0.966 0.005 106.5)",
        "muted-foreground": "oklch(0.58 0.031 107.3)",
        popover: "oklch(1 0 0)",
        "popover-foreground": "oklch(0.153 0.006 107.1)",
        primary: "oklch(0.228 0.013 107.4)",
        "primary-foreground": "oklch(0.988 0.003 106.5)",
        radius: "0.625rem",
        ring: "oklch(0.737 0.021 106.9)",
        secondary: "oklch(0.966 0.005 106.5)",
        "secondary-foreground": "oklch(0.228 0.013 107.4)",
        sidebar: "oklch(0.988 0.003 106.5)",
        "sidebar-accent": "oklch(0.966 0.005 106.5)",
        "sidebar-accent-foreground": "oklch(0.228 0.013 107.4)",
        "sidebar-border": "oklch(0.93 0.007 106.5)",
        "sidebar-foreground": "oklch(0.153 0.006 107.1)",
        "sidebar-primary": "oklch(0.228 0.013 107.4)",
        "sidebar-primary-foreground": "oklch(0.988 0.003 106.5)",
        "sidebar-ring": "oklch(0.737 0.021 106.9)",
      },
    },
    name: "olive",
    title: "Olive",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        accent: "oklch(0.275 0.011 216.9)",
        "accent-foreground": "oklch(0.987 0.002 197.1)",
        background: "oklch(0.148 0.004 228.8)",
        border: "oklch(1 0 0 / 10%)",
        card: "oklch(0.218 0.008 223.9)",
        "card-foreground": "oklch(0.987 0.002 197.1)",
        "chart-1": "oklch(0.872 0.007 219.6)",
        "chart-2": "oklch(0.56 0.021 213.5)",
        "chart-3": "oklch(0.45 0.017 213.2)",
        "chart-4": "oklch(0.378 0.015 216)",
        "chart-5": "oklch(0.275 0.011 216.9)",
        destructive: "oklch(0.704 0.191 22.216)",
        foreground: "oklch(0.987 0.002 197.1)",
        input: "oklch(1 0 0 / 15%)",
        muted: "oklch(0.275 0.011 216.9)",
        "muted-foreground": "oklch(0.723 0.014 214.4)",
        popover: "oklch(0.218 0.008 223.9)",
        "popover-foreground": "oklch(0.987 0.002 197.1)",
        primary: "oklch(0.925 0.005 214.3)",
        "primary-foreground": "oklch(0.218 0.008 223.9)",
        ring: "oklch(0.56 0.021 213.5)",
        secondary: "oklch(0.275 0.011 216.9)",
        "secondary-foreground": "oklch(0.987 0.002 197.1)",
        sidebar: "oklch(0.218 0.008 223.9)",
        "sidebar-accent": "oklch(0.275 0.011 216.9)",
        "sidebar-accent-foreground": "oklch(0.987 0.002 197.1)",
        "sidebar-border": "oklch(1 0 0 / 10%)",
        "sidebar-foreground": "oklch(0.987 0.002 197.1)",
        "sidebar-primary": "oklch(0.488 0.243 264.376)",
        "sidebar-primary-foreground": "oklch(0.987 0.002 197.1)",
        "sidebar-ring": "oklch(0.56 0.021 213.5)",
      },
      light: {
        accent: "oklch(0.963 0.002 197.1)",
        "accent-foreground": "oklch(0.218 0.008 223.9)",
        background: "oklch(1 0 0)",
        border: "oklch(0.925 0.005 214.3)",
        card: "oklch(1 0 0)",
        "card-foreground": "oklch(0.148 0.004 228.8)",
        "chart-1": "oklch(0.872 0.007 219.6)",
        "chart-2": "oklch(0.56 0.021 213.5)",
        "chart-3": "oklch(0.45 0.017 213.2)",
        "chart-4": "oklch(0.378 0.015 216)",
        "chart-5": "oklch(0.275 0.011 216.9)",
        destructive: "oklch(0.577 0.245 27.325)",
        foreground: "oklch(0.148 0.004 228.8)",
        input: "oklch(0.925 0.005 214.3)",
        muted: "oklch(0.963 0.002 197.1)",
        "muted-foreground": "oklch(0.56 0.021 213.5)",
        popover: "oklch(1 0 0)",
        "popover-foreground": "oklch(0.148 0.004 228.8)",
        primary: "oklch(0.218 0.008 223.9)",
        "primary-foreground": "oklch(0.987 0.002 197.1)",
        radius: "0.625rem",
        ring: "oklch(0.723 0.014 214.4)",
        secondary: "oklch(0.963 0.002 197.1)",
        "secondary-foreground": "oklch(0.218 0.008 223.9)",
        sidebar: "oklch(0.987 0.002 197.1)",
        "sidebar-accent": "oklch(0.963 0.002 197.1)",
        "sidebar-accent-foreground": "oklch(0.218 0.008 223.9)",
        "sidebar-border": "oklch(0.925 0.005 214.3)",
        "sidebar-foreground": "oklch(0.148 0.004 228.8)",
        "sidebar-primary": "oklch(0.218 0.008 223.9)",
        "sidebar-primary-foreground": "oklch(0.987 0.002 197.1)",
        "sidebar-ring": "oklch(0.723 0.014 214.4)",
      },
    },
    name: "mist",
    title: "Mist",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        accent: "oklch(0.268 0.011 36.5)",
        "accent-foreground": "oklch(0.986 0.002 67.8)",
        background: "oklch(0.147 0.004 49.3)",
        border: "oklch(1 0 0 / 10%)",
        card: "oklch(0.214 0.009 43.1)",
        "card-foreground": "oklch(0.986 0.002 67.8)",
        "chart-1": "oklch(0.868 0.007 39.5)",
        "chart-2": "oklch(0.547 0.021 43.1)",
        "chart-3": "oklch(0.438 0.017 39.3)",
        "chart-4": "oklch(0.367 0.016 35.7)",
        "chart-5": "oklch(0.268 0.011 36.5)",
        destructive: "oklch(0.704 0.191 22.216)",
        foreground: "oklch(0.986 0.002 67.8)",
        input: "oklch(1 0 0 / 15%)",
        muted: "oklch(0.268 0.011 36.5)",
        "muted-foreground": "oklch(0.714 0.014 41.2)",
        popover: "oklch(0.214 0.009 43.1)",
        "popover-foreground": "oklch(0.986 0.002 67.8)",
        primary: "oklch(0.922 0.005 34.3)",
        "primary-foreground": "oklch(0.214 0.009 43.1)",
        ring: "oklch(0.547 0.021 43.1)",
        secondary: "oklch(0.268 0.011 36.5)",
        "secondary-foreground": "oklch(0.986 0.002 67.8)",
        sidebar: "oklch(0.214 0.009 43.1)",
        "sidebar-accent": "oklch(0.268 0.011 36.5)",
        "sidebar-accent-foreground": "oklch(0.986 0.002 67.8)",
        "sidebar-border": "oklch(1 0 0 / 10%)",
        "sidebar-foreground": "oklch(0.986 0.002 67.8)",
        "sidebar-primary": "oklch(0.488 0.243 264.376)",
        "sidebar-primary-foreground": "oklch(0.986 0.002 67.8)",
        "sidebar-ring": "oklch(0.547 0.021 43.1)",
      },
      light: {
        accent: "oklch(0.96 0.002 17.2)",
        "accent-foreground": "oklch(0.214 0.009 43.1)",
        background: "oklch(1 0 0)",
        border: "oklch(0.922 0.005 34.3)",
        card: "oklch(1 0 0)",
        "card-foreground": "oklch(0.147 0.004 49.3)",
        "chart-1": "oklch(0.868 0.007 39.5)",
        "chart-2": "oklch(0.547 0.021 43.1)",
        "chart-3": "oklch(0.438 0.017 39.3)",
        "chart-4": "oklch(0.367 0.016 35.7)",
        "chart-5": "oklch(0.268 0.011 36.5)",
        destructive: "oklch(0.577 0.245 27.325)",
        foreground: "oklch(0.147 0.004 49.3)",
        input: "oklch(0.922 0.005 34.3)",
        muted: "oklch(0.96 0.002 17.2)",
        "muted-foreground": "oklch(0.547 0.021 43.1)",
        popover: "oklch(1 0 0)",
        "popover-foreground": "oklch(0.147 0.004 49.3)",
        primary: "oklch(0.214 0.009 43.1)",
        "primary-foreground": "oklch(0.986 0.002 67.8)",
        radius: "0.625rem",
        ring: "oklch(0.714 0.014 41.2)",
        secondary: "oklch(0.96 0.002 17.2)",
        "secondary-foreground": "oklch(0.214 0.009 43.1)",
        sidebar: "oklch(0.986 0.002 67.8)",
        "sidebar-accent": "oklch(0.96 0.002 17.2)",
        "sidebar-accent-foreground": "oklch(0.214 0.009 43.1)",
        "sidebar-border": "oklch(0.922 0.005 34.3)",
        "sidebar-foreground": "oklch(0.147 0.004 49.3)",
        "sidebar-primary": "oklch(0.214 0.009 43.1)",
        "sidebar-primary-foreground": "oklch(0.986 0.002 67.8)",
        "sidebar-ring": "oklch(0.714 0.014 41.2)",
      },
    },
    name: "taupe",
    title: "Taupe",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        "chart-1": "oklch(0.879 0.169 91.605)",
        "chart-2": "oklch(0.769 0.188 70.08)",
        "chart-3": "oklch(0.666 0.179 58.318)",
        "chart-4": "oklch(0.555 0.163 48.998)",
        "chart-5": "oklch(0.473 0.137 46.201)",
        primary: "oklch(0.473 0.137 46.201)",
        "primary-foreground": "oklch(0.987 0.022 95.277)",
        secondary: "oklch(0.274 0.006 286.033)",
        "secondary-foreground": "oklch(0.985 0 0)",
        "sidebar-primary": "oklch(0.769 0.188 70.08)",
        "sidebar-primary-foreground": "oklch(0.279 0.077 45.635)",
      },
      light: {
        "chart-1": "oklch(0.879 0.169 91.605)",
        "chart-2": "oklch(0.769 0.188 70.08)",
        "chart-3": "oklch(0.666 0.179 58.318)",
        "chart-4": "oklch(0.555 0.163 48.998)",
        "chart-5": "oklch(0.473 0.137 46.201)",
        primary: "oklch(0.555 0.163 48.998)",
        "primary-foreground": "oklch(0.987 0.022 95.277)",
        secondary: "oklch(0.967 0.001 286.375)",
        "secondary-foreground": "oklch(0.21 0.006 285.885)",
        "sidebar-primary": "oklch(0.666 0.179 58.318)",
        "sidebar-primary-foreground": "oklch(0.987 0.022 95.277)",
      },
    },
    name: "amber",
    title: "Amber",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        "chart-1": "oklch(0.809 0.105 251.813)",
        "chart-2": "oklch(0.623 0.214 259.815)",
        "chart-3": "oklch(0.546 0.245 262.881)",
        "chart-4": "oklch(0.488 0.243 264.376)",
        "chart-5": "oklch(0.424 0.199 265.638)",
        primary: "oklch(0.424 0.199 265.638)",
        "primary-foreground": "oklch(0.97 0.014 254.604)",
        secondary: "oklch(0.274 0.006 286.033)",
        "secondary-foreground": "oklch(0.985 0 0)",
        "sidebar-primary": "oklch(0.623 0.214 259.815)",
        "sidebar-primary-foreground": "oklch(0.97 0.014 254.604)",
      },
      light: {
        "chart-1": "oklch(0.809 0.105 251.813)",
        "chart-2": "oklch(0.623 0.214 259.815)",
        "chart-3": "oklch(0.546 0.245 262.881)",
        "chart-4": "oklch(0.488 0.243 264.376)",
        "chart-5": "oklch(0.424 0.199 265.638)",
        primary: "oklch(0.488 0.243 264.376)",
        "primary-foreground": "oklch(0.97 0.014 254.604)",
        secondary: "oklch(0.967 0.001 286.375)",
        "secondary-foreground": "oklch(0.21 0.006 285.885)",
        "sidebar-primary": "oklch(0.546 0.245 262.881)",
        "sidebar-primary-foreground": "oklch(0.97 0.014 254.604)",
      },
    },
    name: "blue",
    title: "Blue",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        "chart-1": "oklch(0.865 0.127 207.078)",
        "chart-2": "oklch(0.715 0.143 215.221)",
        "chart-3": "oklch(0.609 0.126 221.723)",
        "chart-4": "oklch(0.52 0.105 223.128)",
        "chart-5": "oklch(0.45 0.085 224.283)",
        primary: "oklch(0.45 0.085 224.283)",
        "primary-foreground": "oklch(0.984 0.019 200.873)",
        secondary: "oklch(0.274 0.006 286.033)",
        "secondary-foreground": "oklch(0.985 0 0)",
        "sidebar-primary": "oklch(0.715 0.143 215.221)",
        "sidebar-primary-foreground": "oklch(0.302 0.056 229.695)",
      },
      light: {
        "chart-1": "oklch(0.865 0.127 207.078)",
        "chart-2": "oklch(0.715 0.143 215.221)",
        "chart-3": "oklch(0.609 0.126 221.723)",
        "chart-4": "oklch(0.52 0.105 223.128)",
        "chart-5": "oklch(0.45 0.085 224.283)",
        primary: "oklch(0.52 0.105 223.128)",
        "primary-foreground": "oklch(0.984 0.019 200.873)",
        secondary: "oklch(0.967 0.001 286.375)",
        "secondary-foreground": "oklch(0.21 0.006 285.885)",
        "sidebar-primary": "oklch(0.609 0.126 221.723)",
        "sidebar-primary-foreground": "oklch(0.984 0.019 200.873)",
      },
    },
    name: "cyan",
    title: "Cyan",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        "chart-1": "oklch(0.845 0.143 164.978)",
        "chart-2": "oklch(0.696 0.17 162.48)",
        "chart-3": "oklch(0.596 0.145 163.225)",
        "chart-4": "oklch(0.508 0.118 165.612)",
        "chart-5": "oklch(0.432 0.095 166.913)",
        primary: "oklch(0.432 0.095 166.913)",
        "primary-foreground": "oklch(0.979 0.021 166.113)",
        secondary: "oklch(0.274 0.006 286.033)",
        "secondary-foreground": "oklch(0.985 0 0)",
        "sidebar-primary": "oklch(0.696 0.17 162.48)",
        "sidebar-primary-foreground": "oklch(0.262 0.051 172.552)",
      },
      light: {
        "chart-1": "oklch(0.845 0.143 164.978)",
        "chart-2": "oklch(0.696 0.17 162.48)",
        "chart-3": "oklch(0.596 0.145 163.225)",
        "chart-4": "oklch(0.508 0.118 165.612)",
        "chart-5": "oklch(0.432 0.095 166.913)",
        primary: "oklch(0.508 0.118 165.612)",
        "primary-foreground": "oklch(0.979 0.021 166.113)",
        secondary: "oklch(0.967 0.001 286.375)",
        "secondary-foreground": "oklch(0.21 0.006 285.885)",
        "sidebar-primary": "oklch(0.596 0.145 163.225)",
        "sidebar-primary-foreground": "oklch(0.979 0.021 166.113)",
      },
    },
    name: "emerald",
    title: "Emerald",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        "chart-1": "oklch(0.833 0.145 321.434)",
        "chart-2": "oklch(0.667 0.295 322.15)",
        "chart-3": "oklch(0.591 0.293 322.896)",
        "chart-4": "oklch(0.518 0.253 323.949)",
        "chart-5": "oklch(0.452 0.211 324.591)",
        primary: "oklch(0.452 0.211 324.591)",
        "primary-foreground": "oklch(0.977 0.017 320.058)",
        secondary: "oklch(0.274 0.006 286.033)",
        "secondary-foreground": "oklch(0.985 0 0)",
        "sidebar-primary": "oklch(0.667 0.295 322.15)",
        "sidebar-primary-foreground": "oklch(0.977 0.017 320.058)",
      },
      light: {
        "chart-1": "oklch(0.833 0.145 321.434)",
        "chart-2": "oklch(0.667 0.295 322.15)",
        "chart-3": "oklch(0.591 0.293 322.896)",
        "chart-4": "oklch(0.518 0.253 323.949)",
        "chart-5": "oklch(0.452 0.211 324.591)",
        primary: "oklch(0.518 0.253 323.949)",
        "primary-foreground": "oklch(0.977 0.017 320.058)",
        secondary: "oklch(0.967 0.001 286.375)",
        "secondary-foreground": "oklch(0.21 0.006 285.885)",
        "sidebar-primary": "oklch(0.591 0.293 322.896)",
        "sidebar-primary-foreground": "oklch(0.977 0.017 320.058)",
      },
    },
    name: "fuchsia",
    title: "Fuchsia",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        "chart-1": "oklch(0.871 0.15 154.449)",
        "chart-2": "oklch(0.723 0.219 149.579)",
        "chart-3": "oklch(0.627 0.194 149.214)",
        "chart-4": "oklch(0.527 0.154 150.069)",
        "chart-5": "oklch(0.448 0.119 151.328)",
        primary: "oklch(0.448 0.119 151.328)",
        "primary-foreground": "oklch(0.982 0.018 155.826)",
        secondary: "oklch(0.274 0.006 286.033)",
        "secondary-foreground": "oklch(0.985 0 0)",
        "sidebar-primary": "oklch(0.723 0.219 149.579)",
        "sidebar-primary-foreground": "oklch(0.982 0.018 155.826)",
      },
      light: {
        "chart-1": "oklch(0.871 0.15 154.449)",
        "chart-2": "oklch(0.723 0.219 149.579)",
        "chart-3": "oklch(0.627 0.194 149.214)",
        "chart-4": "oklch(0.527 0.154 150.069)",
        "chart-5": "oklch(0.448 0.119 151.328)",
        primary: "oklch(0.527 0.154 150.069)",
        "primary-foreground": "oklch(0.982 0.018 155.826)",
        secondary: "oklch(0.967 0.001 286.375)",
        "secondary-foreground": "oklch(0.21 0.006 285.885)",
        "sidebar-primary": "oklch(0.627 0.194 149.214)",
        "sidebar-primary-foreground": "oklch(0.982 0.018 155.826)",
      },
    },
    name: "green",
    title: "Green",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        "chart-1": "oklch(0.785 0.115 274.713)",
        "chart-2": "oklch(0.585 0.233 277.117)",
        "chart-3": "oklch(0.511 0.262 276.966)",
        "chart-4": "oklch(0.457 0.24 277.023)",
        "chart-5": "oklch(0.398 0.195 277.366)",
        primary: "oklch(0.398 0.195 277.366)",
        "primary-foreground": "oklch(0.962 0.018 272.314)",
        secondary: "oklch(0.274 0.006 286.033)",
        "secondary-foreground": "oklch(0.985 0 0)",
        "sidebar-primary": "oklch(0.585 0.233 277.117)",
        "sidebar-primary-foreground": "oklch(0.962 0.018 272.314)",
      },
      light: {
        "chart-1": "oklch(0.785 0.115 274.713)",
        "chart-2": "oklch(0.585 0.233 277.117)",
        "chart-3": "oklch(0.511 0.262 276.966)",
        "chart-4": "oklch(0.457 0.24 277.023)",
        "chart-5": "oklch(0.398 0.195 277.366)",
        primary: "oklch(0.457 0.24 277.023)",
        "primary-foreground": "oklch(0.962 0.018 272.314)",
        secondary: "oklch(0.967 0.001 286.375)",
        "secondary-foreground": "oklch(0.21 0.006 285.885)",
        "sidebar-primary": "oklch(0.511 0.262 276.966)",
        "sidebar-primary-foreground": "oklch(0.962 0.018 272.314)",
      },
    },
    name: "indigo",
    title: "Indigo",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        "chart-1": "oklch(0.897 0.196 126.665)",
        "chart-2": "oklch(0.768 0.233 130.85)",
        "chart-3": "oklch(0.648 0.2 131.684)",
        "chart-4": "oklch(0.532 0.157 131.589)",
        "chart-5": "oklch(0.453 0.124 130.933)",
        primary: "oklch(0.768 0.233 130.85)",
        "primary-foreground": "oklch(0.405 0.101 131.063)",
        secondary: "oklch(0.274 0.006 286.033)",
        "secondary-foreground": "oklch(0.985 0 0)",
        "sidebar-primary": "oklch(0.768 0.233 130.85)",
        "sidebar-primary-foreground": "oklch(0.274 0.072 132.109)",
      },
      light: {
        "chart-1": "oklch(0.897 0.196 126.665)",
        "chart-2": "oklch(0.768 0.233 130.85)",
        "chart-3": "oklch(0.648 0.2 131.684)",
        "chart-4": "oklch(0.532 0.157 131.589)",
        "chart-5": "oklch(0.453 0.124 130.933)",
        primary: "oklch(0.841 0.238 128.85)",
        "primary-foreground": "oklch(0.405 0.101 131.063)",
        secondary: "oklch(0.967 0.001 286.375)",
        "secondary-foreground": "oklch(0.21 0.006 285.885)",
        "sidebar-primary": "oklch(0.648 0.2 131.684)",
        "sidebar-primary-foreground": "oklch(0.986 0.031 120.757)",
      },
    },
    name: "lime",
    title: "Lime",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        "chart-1": "oklch(0.837 0.128 66.29)",
        "chart-2": "oklch(0.705 0.213 47.604)",
        "chart-3": "oklch(0.646 0.222 41.116)",
        "chart-4": "oklch(0.553 0.195 38.402)",
        "chart-5": "oklch(0.47 0.157 37.304)",
        primary: "oklch(0.47 0.157 37.304)",
        "primary-foreground": "oklch(0.98 0.016 73.684)",
        secondary: "oklch(0.274 0.006 286.033)",
        "secondary-foreground": "oklch(0.985 0 0)",
        "sidebar-primary": "oklch(0.705 0.213 47.604)",
        "sidebar-primary-foreground": "oklch(0.98 0.016 73.684)",
      },
      light: {
        "chart-1": "oklch(0.837 0.128 66.29)",
        "chart-2": "oklch(0.705 0.213 47.604)",
        "chart-3": "oklch(0.646 0.222 41.116)",
        "chart-4": "oklch(0.553 0.195 38.402)",
        "chart-5": "oklch(0.47 0.157 37.304)",
        primary: "oklch(0.553 0.195 38.402)",
        "primary-foreground": "oklch(0.98 0.016 73.684)",
        secondary: "oklch(0.967 0.001 286.375)",
        "secondary-foreground": "oklch(0.21 0.006 285.885)",
        "sidebar-primary": "oklch(0.646 0.222 41.116)",
        "sidebar-primary-foreground": "oklch(0.98 0.016 73.684)",
      },
    },
    name: "orange",
    title: "Orange",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        "chart-1": "oklch(0.823 0.12 346.018)",
        "chart-2": "oklch(0.656 0.241 354.308)",
        "chart-3": "oklch(0.592 0.249 0.584)",
        "chart-4": "oklch(0.525 0.223 3.958)",
        "chart-5": "oklch(0.459 0.187 3.815)",
        primary: "oklch(0.459 0.187 3.815)",
        "primary-foreground": "oklch(0.971 0.014 343.198)",
        secondary: "oklch(0.274 0.006 286.033)",
        "secondary-foreground": "oklch(0.985 0 0)",
        "sidebar-primary": "oklch(0.656 0.241 354.308)",
        "sidebar-primary-foreground": "oklch(0.971 0.014 343.198)",
      },
      light: {
        "chart-1": "oklch(0.823 0.12 346.018)",
        "chart-2": "oklch(0.656 0.241 354.308)",
        "chart-3": "oklch(0.592 0.249 0.584)",
        "chart-4": "oklch(0.525 0.223 3.958)",
        "chart-5": "oklch(0.459 0.187 3.815)",
        primary: "oklch(0.525 0.223 3.958)",
        "primary-foreground": "oklch(0.971 0.014 343.198)",
        secondary: "oklch(0.967 0.001 286.375)",
        "secondary-foreground": "oklch(0.21 0.006 285.885)",
        "sidebar-primary": "oklch(0.592 0.249 0.584)",
        "sidebar-primary-foreground": "oklch(0.971 0.014 343.198)",
      },
    },
    name: "pink",
    title: "Pink",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        "chart-1": "oklch(0.827 0.119 306.383)",
        "chart-2": "oklch(0.627 0.265 303.9)",
        "chart-3": "oklch(0.558 0.288 302.321)",
        "chart-4": "oklch(0.496 0.265 301.924)",
        "chart-5": "oklch(0.438 0.218 303.724)",
        primary: "oklch(0.438 0.218 303.724)",
        "primary-foreground": "oklch(0.977 0.014 308.299)",
        secondary: "oklch(0.274 0.006 286.033)",
        "secondary-foreground": "oklch(0.985 0 0)",
        "sidebar-primary": "oklch(0.627 0.265 303.9)",
        "sidebar-primary-foreground": "oklch(0.977 0.014 308.299)",
      },
      light: {
        "chart-1": "oklch(0.827 0.119 306.383)",
        "chart-2": "oklch(0.627 0.265 303.9)",
        "chart-3": "oklch(0.558 0.288 302.321)",
        "chart-4": "oklch(0.496 0.265 301.924)",
        "chart-5": "oklch(0.438 0.218 303.724)",
        primary: "oklch(0.496 0.265 301.924)",
        "primary-foreground": "oklch(0.977 0.014 308.299)",
        secondary: "oklch(0.967 0.001 286.375)",
        "secondary-foreground": "oklch(0.21 0.006 285.885)",
        "sidebar-primary": "oklch(0.558 0.288 302.321)",
        "sidebar-primary-foreground": "oklch(0.977 0.014 308.299)",
      },
    },
    name: "purple",
    title: "Purple",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        "chart-1": "oklch(0.808 0.114 19.571)",
        "chart-2": "oklch(0.637 0.237 25.331)",
        "chart-3": "oklch(0.577 0.245 27.325)",
        "chart-4": "oklch(0.505 0.213 27.518)",
        "chart-5": "oklch(0.444 0.177 26.899)",
        primary: "oklch(0.444 0.177 26.899)",
        "primary-foreground": "oklch(0.971 0.013 17.38)",
        secondary: "oklch(0.274 0.006 286.033)",
        "secondary-foreground": "oklch(0.985 0 0)",
        "sidebar-primary": "oklch(0.637 0.237 25.331)",
        "sidebar-primary-foreground": "oklch(0.971 0.013 17.38)",
      },
      light: {
        "chart-1": "oklch(0.808 0.114 19.571)",
        "chart-2": "oklch(0.637 0.237 25.331)",
        "chart-3": "oklch(0.577 0.245 27.325)",
        "chart-4": "oklch(0.505 0.213 27.518)",
        "chart-5": "oklch(0.444 0.177 26.899)",
        primary: "oklch(0.505 0.213 27.518)",
        "primary-foreground": "oklch(0.971 0.013 17.38)",
        secondary: "oklch(0.967 0.001 286.375)",
        "secondary-foreground": "oklch(0.21 0.006 285.885)",
        "sidebar-primary": "oklch(0.577 0.245 27.325)",
        "sidebar-primary-foreground": "oklch(0.971 0.013 17.38)",
      },
    },
    name: "red",
    title: "Red",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        "chart-1": "oklch(0.81 0.117 11.638)",
        "chart-2": "oklch(0.645 0.246 16.439)",
        "chart-3": "oklch(0.586 0.253 17.585)",
        "chart-4": "oklch(0.514 0.222 16.935)",
        "chart-5": "oklch(0.455 0.188 13.697)",
        primary: "oklch(0.455 0.188 13.697)",
        "primary-foreground": "oklch(0.969 0.015 12.422)",
        secondary: "oklch(0.274 0.006 286.033)",
        "secondary-foreground": "oklch(0.985 0 0)",
        sidebar: "oklch(0.21 0.006 285.885)",
        "sidebar-primary": "oklch(0.645 0.246 16.439)",
        "sidebar-primary-foreground": "oklch(0.969 0.015 12.422)",
      },
      light: {
        "chart-1": "oklch(0.81 0.117 11.638)",
        "chart-2": "oklch(0.645 0.246 16.439)",
        "chart-3": "oklch(0.586 0.253 17.585)",
        "chart-4": "oklch(0.514 0.222 16.935)",
        "chart-5": "oklch(0.455 0.188 13.697)",
        primary: "oklch(0.514 0.222 16.935)",
        "primary-foreground": "oklch(0.969 0.015 12.422)",
        secondary: "oklch(0.967 0.001 286.375)",
        "secondary-foreground": "oklch(0.21 0.006 285.885)",
        "sidebar-primary": "oklch(0.586 0.253 17.585)",
        "sidebar-primary-foreground": "oklch(0.969 0.015 12.422)",
      },
    },
    name: "rose",
    title: "Rose",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        "chart-1": "oklch(0.828 0.111 230.318)",
        "chart-2": "oklch(0.685 0.169 237.323)",
        "chart-3": "oklch(0.588 0.158 241.966)",
        "chart-4": "oklch(0.5 0.134 242.749)",
        "chart-5": "oklch(0.443 0.11 240.79)",
        primary: "oklch(0.443 0.11 240.79)",
        "primary-foreground": "oklch(0.977 0.013 236.62)",
        secondary: "oklch(0.274 0.006 286.033)",
        "secondary-foreground": "oklch(0.985 0 0)",
        "sidebar-primary": "oklch(0.685 0.169 237.323)",
        "sidebar-primary-foreground": "oklch(0.293 0.066 243.157)",
      },
      light: {
        "chart-1": "oklch(0.828 0.111 230.318)",
        "chart-2": "oklch(0.685 0.169 237.323)",
        "chart-3": "oklch(0.588 0.158 241.966)",
        "chart-4": "oklch(0.5 0.134 242.749)",
        "chart-5": "oklch(0.443 0.11 240.79)",
        primary: "oklch(0.5 0.134 242.749)",
        "primary-foreground": "oklch(0.977 0.013 236.62)",
        secondary: "oklch(0.967 0.001 286.375)",
        "secondary-foreground": "oklch(0.21 0.006 285.885)",
        "sidebar-primary": "oklch(0.588 0.158 241.966)",
        "sidebar-primary-foreground": "oklch(0.977 0.013 236.62)",
      },
    },
    name: "sky",
    title: "Sky",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        "chart-1": "oklch(0.855 0.138 181.071)",
        "chart-2": "oklch(0.704 0.14 182.503)",
        "chart-3": "oklch(0.6 0.118 184.704)",
        "chart-4": "oklch(0.511 0.096 186.391)",
        "chart-5": "oklch(0.437 0.078 188.216)",
        primary: "oklch(0.437 0.078 188.216)",
        "primary-foreground": "oklch(0.984 0.014 180.72)",
        secondary: "oklch(0.274 0.006 286.033)",
        "secondary-foreground": "oklch(0.985 0 0)",
        "sidebar-primary": "oklch(0.704 0.14 182.503)",
        "sidebar-primary-foreground": "oklch(0.277 0.046 192.524)",
      },
      light: {
        "chart-1": "oklch(0.855 0.138 181.071)",
        "chart-2": "oklch(0.704 0.14 182.503)",
        "chart-3": "oklch(0.6 0.118 184.704)",
        "chart-4": "oklch(0.511 0.096 186.391)",
        "chart-5": "oklch(0.437 0.078 188.216)",
        primary: "oklch(0.511 0.096 186.391)",
        "primary-foreground": "oklch(0.984 0.014 180.72)",
        secondary: "oklch(0.967 0.001 286.375)",
        "secondary-foreground": "oklch(0.21 0.006 285.885)",
        "sidebar-primary": "oklch(0.6 0.118 184.704)",
        "sidebar-primary-foreground": "oklch(0.984 0.014 180.72)",
      },
    },
    name: "teal",
    title: "Teal",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        "chart-1": "oklch(0.811 0.111 293.571)",
        "chart-2": "oklch(0.606 0.25 292.717)",
        "chart-3": "oklch(0.541 0.281 293.009)",
        "chart-4": "oklch(0.491 0.27 292.581)",
        "chart-5": "oklch(0.432 0.232 292.759)",
        primary: "oklch(0.432 0.232 292.759)",
        "primary-foreground": "oklch(0.969 0.016 293.756)",
        secondary: "oklch(0.274 0.006 286.033)",
        "secondary-foreground": "oklch(0.985 0 0)",
        "sidebar-primary": "oklch(0.606 0.25 292.717)",
        "sidebar-primary-foreground": "oklch(0.969 0.016 293.756)",
      },
      light: {
        "chart-1": "oklch(0.811 0.111 293.571)",
        "chart-2": "oklch(0.606 0.25 292.717)",
        "chart-3": "oklch(0.541 0.281 293.009)",
        "chart-4": "oklch(0.491 0.27 292.581)",
        "chart-5": "oklch(0.432 0.232 292.759)",
        primary: "oklch(0.491 0.27 292.581)",
        "primary-foreground": "oklch(0.969 0.016 293.756)",
        secondary: "oklch(0.967 0.001 286.375)",
        "secondary-foreground": "oklch(0.21 0.006 285.885)",
        "sidebar-primary": "oklch(0.541 0.281 293.009)",
        "sidebar-primary-foreground": "oklch(0.969 0.016 293.756)",
      },
    },
    name: "violet",
    title: "Violet",
    type: "registry:theme",
  },
  {
    cssVars: {
      dark: {
        "chart-1": "oklch(0.905 0.182 98.111)",
        "chart-2": "oklch(0.795 0.184 86.047)",
        "chart-3": "oklch(0.681 0.162 75.834)",
        "chart-4": "oklch(0.554 0.135 66.442)",
        "chart-5": "oklch(0.476 0.114 61.907)",
        primary: "oklch(0.795 0.184 86.047)",
        "primary-foreground": "oklch(0.421 0.095 57.708)",
        secondary: "oklch(0.274 0.006 286.033)",
        "secondary-foreground": "oklch(0.985 0 0)",
        "sidebar-primary": "oklch(0.795 0.184 86.047)",
        "sidebar-primary-foreground": "oklch(0.987 0.026 102.212)",
      },
      light: {
        "chart-1": "oklch(0.905 0.182 98.111)",
        "chart-2": "oklch(0.795 0.184 86.047)",
        "chart-3": "oklch(0.681 0.162 75.834)",
        "chart-4": "oklch(0.554 0.135 66.442)",
        "chart-5": "oklch(0.476 0.114 61.907)",
        primary: "oklch(0.852 0.199 91.936)",
        "primary-foreground": "oklch(0.421 0.095 57.708)",
        secondary: "oklch(0.967 0.001 286.375)",
        "secondary-foreground": "oklch(0.21 0.006 285.885)",
        "sidebar-primary": "oklch(0.681 0.162 75.834)",
        "sidebar-primary-foreground": "oklch(0.987 0.026 102.212)",
      },
    },
    name: "yellow",
    title: "Yellow",
    type: "registry:theme",
  },
] as const satisfies RegistryItem[];

export type Theme = (typeof THEMES)[number];
